import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { ReportProblem } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import { theme } from "../../../theme";
import "./index.scss";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  maxWidth: 500,
  bgcolor: "#fff",
  boxShadow: 24,
  borderRadius: "20px",
  p: 4,
  pb: 4,
};

const CustomModal = (props: any) => {
  const { open, onClose, onContinue, title, message, leftButton, rightButton } =
    props;

  return (
    <Modal
      open={open}
      onClose={() => onClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "100%",
              padding: "1rem",
              backgroundColor: theme.palette.primary.main,
            }}
          >
            <ReportProblem
              fontSize="large"
              sx={{
                color: "#fff",
              }}
            />
          </Box>
          <Box component="br" />
          {title && (
            <Typography
              component="h1"
              variant="h3"
            >
              {title}
            </Typography>
          )}
          <Typography
            component="h5"
            variant="body2"
            className="warning-message"
          >
            {message}
          </Typography>

          <Box
            sx={{
              width: "100%",
            }}
          >
            <Button
              variant="contained"
              onClick={onClose}
              sx={{
                width: "45%",
                mr: 3,
                mt: 2,
              }}
            >
              {leftButton}
            </Button>
            <Button
              variant="contained"
              onClick={onContinue}
              sx={{
                width: "45%",
                mt: 2,
              }}
            >
              {rightButton}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
export default CustomModal;
